<template>
  <div class="free-delivery" v-if="cart.originCost && cart.originCost > 0">
    <InfoMessage
      v-if="summBeforeFree > 0"
      :title="$t('free_delivery.title_not_free', { n: summBeforeFree })"
      :show-delivery-status="true"
      :text="$t('free_delivery.tooltip')"
      :with-tooltip="true"
      type="delivery"
    />
    <InfoMessage
      v-else
      :title="$t('free_delivery.title_free')"
      :text="$t('free_delivery.tooltip')"
      :with-tooltip="true"
      type="delivery"
    />
  </div>
</template>

<script>
import InfoMessage from '@/components/helpers/InfoMessage.vue'
import {
  NOVA_POSHTA_PRICE_LIMIT,
  NOVA_POSHTA_COURIER_PRICE_LIMIT,
  UKR_POSHTA_PRICE_LIMIT,
  COURIER_PRICE_LIMIT,
  NOVA_POSHTA_POSTOMAT_PRICE_LIMIT
} from '@/constants'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'FreeDelivery',
  components: { InfoMessage },
  computed: {
    ...mapState({
      cart: state => state.cart.cart,
      deliveryType: state => state.checkout.formData.deliveryType
    }),
    ...mapGetters([
      'currentBonuses'
    ]),
    summBeforeFree () {
      let priceLimit = Math.min(NOVA_POSHTA_PRICE_LIMIT, NOVA_POSHTA_COURIER_PRICE_LIMIT, UKR_POSHTA_PRICE_LIMIT, COURIER_PRICE_LIMIT, NOVA_POSHTA_POSTOMAT_PRICE_LIMIT)
      if (this.deliveryType?.methodId === 5) {
        priceLimit = UKR_POSHTA_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 3 || this.deliveryType === 9) {
        priceLimit = NOVA_POSHTA_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 2) {
        priceLimit = COURIER_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 4) {
        priceLimit = NOVA_POSHTA_COURIER_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 7) {
        priceLimit = NOVA_POSHTA_POSTOMAT_PRICE_LIMIT
      }
      if (this.deliveryType?.methodId === 1) {
        priceLimit = 0
      }
      return priceLimit + 1 - this.cart.originCost + parseInt(this.currentBonuses)
    }
  }
}
</script>

<style lang="sass" scoped>
.free-delivery
  width: 100%
</style>
